<template>
  <v-dialog
    content-class="dialog-zoom dialog-confirm"
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
    persistent
  >
    <v-card>
      <v-system-bar height="16" :color="options.barColor"></v-system-bar>
      <v-card-title style="word-break: break-word;"><div v-html="title"/></v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text><div v-html="message"/></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="!noButtonHide" color="primaryText" class="primary--text" @click.native="cancel">{{
          noText
        }}</v-btn>
        <v-btn color="primary" class="primaryText--text" @click.native="agree">{{ yesText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    title: null,
    subtitle: null,
    message: null,
    options: {},
  }),

  computed: {
    yesText() {
      let text = this.options.yesText;
      if (this.options.translate) {
        text = this.$t(text);
      }
      return text;
    },

    noText() {
      let text = this.options.noText;
      if (this.options.translate) {
        text = this.$t(text);
      }
      return text;
    },

    noButtonHide() {
      return this.options.noButtonHide;
    },
  },

  methods: {
    open(title, subtitle, message, options = null) {
      this.dialog = true;
      this.title = title;
      this.subtitle = subtitle;
      this.message = message;
      this.options = {
        yesText: "yes",
        noText: "no",
        noButtonHide: false,
        translate: true,
        timer: 0,
        width: 300,
        barColor: "primary",
      };
      if (options) {
        this.options = Object.assign(this.options, options);
      }
      if (this.options.timer > 0) {
        setTimeout(() => this.close(), this.options.timer);
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      if (this.resolve) this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      if (this.resolve) this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
